<template lang="pug">
el-aside(v-if="isAuthenticated" v-loading="fetchingData")
  el-alert(
    v-if="error"
    :title="error.message || error.response.data.errorMessage"
    type="error"
    :description="error.stack || error.response.data.stackTrace"
    show-icon)
  el-menu(v-else)
    el-submenu(v-for="(airport, index) in airports"
      :index="airport.id"
      :key="airport.id")
      template(slot="title")
        i.el-icon-location(:class="{'success': airport.published}")
        span(slot="title" :class="{'success': airport.published}")
          | {{airport.code | uppercase}}
      el-menu-item(:index="index + '-settings'")
        router-link(:to="{name: 'AdminAirport', params: {id: airport.id}}")
          i.el-icon-setting
          span Settings
      el-menu-item(:index="index + '-stores'")
        i.el-icon-goods
        router-link(:to="'/airports/' + airport.id + '/stores'") Stores
    el-menu-item(index="add-airport")
      i.el-icon-circle-plus-outline
      router-link(:to="{name: 'NewAdminAirport'}") Add New Airport
</template>

<script>
import AirportsService from '@/services/AirportsService';
import AuthService from '@/services/AuthService';
import EventBus from '@/helpers/event-bus';

export default {
  filters: {
    uppercase(string) {
      if (!string) {
        return '';
      }
      return string.toUpperCase();
    },
  },
  data() {
    return {
      isAuthenticated: AuthService.isAuthenticated,
      fetchingData: false,
      error: true,
      airports: [],
    };
  },
  created() {
    if (AuthService.isAuthenticated) {
      this.getAirports();
    }
    AuthService.authNotifier.on('authChange', authState => {
      this.isAuthenticated = authState.isAuthenticated;
    });
    EventBus.$on('airports-list-modified', this.getAirports);
  },
  methods: {
    getAirports() {
      this.error = null;
      this.fetchingData = true;
      AirportsService.getAirports()
        .then(({ data }) => {
          setTimeout(() => {
            this.airports = data.concat();
          }, 10);
        })
        .catch(error => {
          this.error = error;
        })
        .finally(() => {
          this.fetchingData = false;
        });
    },
  },
  calculated: {
    isAuthenticated: AuthService.isAuthenticated,
  },
};
</script>

<style lang="stylus" scoped>
.el-aside
  max-width 256px
  border-right solid 1px #e6e6e6
  overflow-x hidden

.el-menu
  border none

a
  color #303133
  display inline-block
  width 100%

.success
  color #67C23A
</style>




// WEBPACK FOOTER //
// src/components/AdminSidebar.vue